export default __webpack_public_path__ + "static/media/mechanism_ratio.1ec63a79.webp";